import { useState } from "react";
import { Bot, Send, Clock, MessageSquare, CheckCircle2, ChevronRight, Paperclip, Smile } from "lucide-react";
import { Card } from "../../components/ui/Card";
import { Button } from "../../components/ui/Button";
import { Badge } from "../../components/ui/Badge";
import { previewMessages, chatStats, colorChoices, learningData } from "./mock";

const tabs = [
  "チャットボット設定",
  "学習データ管理",
  "FAQ管理",
  "会話履歴",
  "統計",
];

/**
 * チャットボットページ
 */
export const ChatbotPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [color, setColor] = useState("#2563eb");

  return (
    <div>
      <div className="tabs">
        {tabs.map((t, i) => (
          <button
            key={t}
            className={`tab ${i === activeTab ? "active" : ""}`}
            onClick={() => setActiveTab(i)}
          >
            {t}
          </button>
        ))}
      </div>

      <div className="chatbot-grid">
        {/* 左: 設定 */}
        <Card title="ウィジェット設定" subtitle="表示・挙動を調整します">
          <div className="field">
            <label className="field-label">ウィジェット名</label>
            <input className="input" defaultValue="ポータル商事サポートボット" />
          </div>

          <div className="field">
            <label className="field-label">設置サイトURL</label>
            <input className="input" defaultValue="https://portal-shoji.example.jp" />
          </div>

          <div className="field">
            <label className="field-label">あいさつメッセージ</label>
            <textarea
              className="textarea"
              style={{ minHeight: 90 }}
              defaultValue="こんにちは！株式会社ポータル商事のサポートボットです。どのようなご質問でしょうか？"
            />
          </div>

          <div className="field">
            <label className="field-label">テーマカラー</label>
            <div className="color-swatches">
              {colorChoices.map((c) => (
                <div
                  key={c}
                  className={`color-swatch ${color === c ? "active" : ""}`}
                  style={{ background: c }}
                  onClick={() => setColor(c)}
                />
              ))}
            </div>
          </div>

          <div className="field">
            <label className="field-label">配置位置</label>
            <select className="select" defaultValue="bottom-right">
              <option value="bottom-right">右下</option>
              <option value="bottom-left">左下</option>
            </select>
          </div>

          <div className="row-between" style={{ marginTop: 8 }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>営業時間外も応答</div>
              <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>
                24時間 AI が自動応答します
              </div>
            </div>
            <div className="toggle on" onClick={() => alert("現在はデモ機能です")} />
          </div>

          <hr className="divider" />

          <Button full>保存する</Button>
        </Card>

        {/* 中: プレビュー */}
        <Card title="プレビュー" subtitle="実際の表示イメージです">
          <div className="chat-window">
            <div className="chat-window-head" style={{ background: color, color: "#fff", borderBottom: "none" }}>
              <Bot size={16} />
              <span style={{ flex: 1 }}>ポータル商事サポートボット</span>
              <span style={{ fontSize: 11, opacity: 0.85 }}>● オンライン</span>
            </div>
            <div className="chat-window-body">
              {previewMessages.map((m, i) => (
                <div key={i} className={`chat-msg ${m.role}`}>
                  {m.role === "bot" && (
                    <div className="avatar avatar-sm" style={{ background: color, color: "#fff" }}>
                      <Bot size={13} />
                    </div>
                  )}
                  <div>
                    <div className="chat-bubble" style={m.role === "user" ? { background: color } : undefined}>
                      {m.text.split("\n").map((line, k) => (
                        <div key={k}>{line}</div>
                      ))}
                    </div>
                    <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 4, textAlign: m.role === "user" ? "right" : "left" }}>
                      {m.time}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="chat-window-foot">
              <button className="btn-icon" onClick={() => alert("現在はデモ機能です")}>
                <Paperclip size={14} />
              </button>
              <input className="chat-input" placeholder="メッセージを入力..." />
              <button className="btn-icon" onClick={() => alert("現在はデモ機能です")}>
                <Smile size={14} />
              </button>
              <Button onClick={() => alert("現在はデモ機能です")} iconRight={<Send size={14} />}>
                送信
              </Button>
            </div>
          </div>
        </Card>

        {/* 右: 統計 */}
        <Card title="今日のサマリー">
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div
              style={{
                background: "#eff6ff",
                border: "1px solid #bfdbfe",
                borderRadius: 12,
                padding: 14,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, color: "#1d4ed8" }}>
                <MessageSquare size={14} />
                <span style={{ fontSize: 12, fontWeight: 600 }}>問い合わせ対応数</span>
              </div>
              <div style={{ fontSize: 26, fontWeight: 800, color: "#111827", lineHeight: 1.1 }}>
                {chatStats.todayInquiries}
              </div>
              <div style={{ fontSize: 11, color: "#16a34a", marginTop: 4, fontWeight: 600 }}>+18% vs 昨日</div>
            </div>

            <div
              style={{
                background: "#dcfce7",
                border: "1px solid #bbf7d0",
                borderRadius: 12,
                padding: 14,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, color: "#15803d" }}>
                <CheckCircle2 size={14} />
                <span style={{ fontSize: 12, fontWeight: 600 }}>解決率</span>
              </div>
              <div style={{ fontSize: 26, fontWeight: 800, color: "#111827", lineHeight: 1.1 }}>
                {chatStats.resolutionRate}%
              </div>
              <div className="progress" style={{ marginTop: 8 }}>
                <div className="progress-bar green" style={{ width: `${chatStats.resolutionRate}%` }} />
              </div>
            </div>

            <div
              style={{
                background: "#fef3c7",
                border: "1px solid #fde68a",
                borderRadius: 12,
                padding: 14,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, color: "#92400e" }}>
                <Clock size={14} />
                <span style={{ fontSize: 12, fontWeight: 600 }}>平均応答時間</span>
              </div>
              <div style={{ fontSize: 26, fontWeight: 800, color: "#111827", lineHeight: 1.1 }}>
                {chatStats.avgResponseTime}
              </div>
              <div style={{ fontSize: 11, color: "#92400e", marginTop: 4, fontWeight: 600 }}>
                目標 2 秒以内をクリア
              </div>
            </div>

            <Button full variant="secondary" iconRight={<ChevronRight size={14} />}>
              詳細レポートを見る
            </Button>
          </div>
        </Card>
      </div>

      {/* 下段: 学習データ */}
      <div className="grid-12" style={{ marginTop: 18 }}>
        <div className="col-12">
          <Card
            title="学習データソース"
            subtitle="ボットが回答に利用しているデータ"
            actions={<Button variant="secondary">+ データ追加</Button>}
          >
            <div className="grid-12" style={{ gap: 12 }}>
              {learningData.map((d) => (
                <div className="col-3" key={d.source}>
                  <div
                    style={{
                      border: "1px solid #e5e7eb",
                      borderRadius: 12,
                      padding: 14,
                      background: "#fff",
                    }}
                  >
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>{d.source}</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: "#111827" }}>{d.count}</div>
                    <div style={{ marginTop: 8 }}>
                      {d.status === "学習済" ? (
                        <Badge color="green" dot>
                          {d.status}
                        </Badge>
                      ) : (
                        <Badge color="yellow" dot>
                          {d.status}
                        </Badge>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};
